// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"51d3f088","239":"0082d29c","453":"d8ff56f5","667":"bb090126"}[chunkId] + ".chunk.js";
};